import React from 'react';

const SIZE_MAP = {
    large: 36,
    medium: 24,
    small: 16,
    xlarge: 48
};

/**
 * Lightweight spinner replacement for Atlaskit Spinner.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.isCompleting - Unused compatibility prop.
 * @param {string} props.size - Visual size keyword.
 * @param {React$Node} props.text - Optional label shown next to the spinner.
 * @returns {React$Node}
 */
export default function Spinner({ size = 'medium', text }) {
    const dimension = SIZE_MAP[size] || SIZE_MAP.medium;
    const thickness = Math.max(2, Math.round(dimension / 8));

    return (
        <div
            aria-busy = { true }
            aria-live = 'polite'
            style = {{
                alignItems: 'center',
                display: 'inline-flex',
                gap: '10px',
                justifyContent: 'center'
            }}>
            <span
                aria-hidden = { true }
                style = {{
                    animation: 'meethourSpinner 0.8s linear infinite',
                    border: `${thickness}px solid rgba(75, 103, 144, 0.18)`,
                    borderRadius: '50%',
                    borderTopColor: '#4b6790',
                    boxSizing: 'border-box',
                    display: 'inline-block',
                    height: `${dimension}px`,
                    width: `${dimension}px`
                }} />
            {text ? <span>{text}</span> : null}
            <style>
                { '@keyframes meethourSpinner { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }' }
            </style>
        </div>
    );
}
